var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9144 8.81562L11.5976 1.88687C10.7013 1.03875 9.29819 1.03875 8.40256 1.88687L1.10319 8.8C0.660687 9.18625 0.508812 9.79187 0.715687 10.3437C0.922562 10.8944 1.43506 11.25 2.02194 11.25H2.50006V18.125C2.50006 18.47 2.78006 18.75 3.12506 18.75H16.8751C17.2201 18.75 17.5001 18.47 17.5001 18.125V11.25H17.9776C18.5644 11.25 19.0776 10.8937 19.2838 10.3425C19.4907 9.79125 19.3382 9.185 18.9144 8.81562ZM8.12506 17.5V14.375C8.12506 13.3412 8.96631 12.5 10.0001 12.5C11.0338 12.5 11.8751 13.3412 11.8751 14.375V17.5H8.12506ZM17.9776 10H16.8751C16.5301 10 16.2501 10.28 16.2501 10.625V17.5H13.1251V14.375C13.1251 12.6519 11.7232 11.25 10.0001 11.25C8.27694 11.25 6.87506 12.6519 6.87506 14.375V17.5H3.75006V10.625C3.75006 10.28 3.47006 10 3.12506 10H2.02194C1.89756 10 1.80756 9.84437 1.94381 9.72437L9.26194 2.79437C9.67569 2.4025 10.3244 2.4025 10.7382 2.79437L18.0738 9.74062C18.1763 9.82937 18.1132 10 17.9776 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.858b341e193bf55fbc112189efd757fc.svg";
export { ForwardRef as ReactComponent };